import Div from "./div"

interface HorizontalRuleProps {
    marginBottom?: 1 | 2 | 4
}

export const HorizontalRule = (props: HorizontalRuleProps) => {
    const { marginBottom = 1 } = props;
    return (<Div isRow>
        <Div colsLG={8} colsSM={12}>
            <hr aria-hidden="true" className={`ds-u-margin-top--4 ds-u-margin-bottom--${marginBottom} item-section ds-u-visibility--visible`} />
        </Div>        
    </Div>);
}
